const zoneImageCache = {}
const cacheVersions = {}

export const getZoneImageCacheVersion = deviceId => cacheVersions[deviceId] || 0

export const zoneImageCacheKey = (device, source) => {
    if (!device || device.id === undefined || device.id === null) {
        return null
    }
    return `${device.id}:${source}`
}

export const readZoneImageCache = (device, source) => {
    const key = zoneImageCacheKey(device, source)
    return key ? zoneImageCache[key] : null
}

export const writeZoneImageCache = (device, source, data, version = getZoneImageCacheVersion(device && device.id)) => {
    const key = zoneImageCacheKey(device, source)
    if (!key) {
        return
    }
    if (version !== getZoneImageCacheVersion(device.id)) {
        if (data && data.src && data.src.indexOf('blob:') === 0) URL.revokeObjectURL(data.src)
        return
    }
    const prev = zoneImageCache[key]
    if (prev && prev.src && prev.src.indexOf('blob:') === 0 && data && data.src !== prev.src) {
        URL.revokeObjectURL(prev.src)
    }
    zoneImageCache[key] = data
}

export const clearZoneImageCache = (deviceId) => {
    cacheVersions[deviceId] = getZoneImageCacheVersion(deviceId) + 1
    const prefix = `${deviceId}:`
    Object.keys(zoneImageCache).forEach((key) => {
        if (key !== String(deviceId) && key.indexOf(prefix) !== 0) {
            return
        }
        const prev = zoneImageCache[key]
        if (prev && prev.src && prev.src.indexOf('blob:') === 0) {
            URL.revokeObjectURL(prev.src)
        }
        delete zoneImageCache[key]
    })
}
